<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ "Aprobar/Observar" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12>
                <b> Nombre completo:</b> {{ form.nombres }}
              </v-flex>
              <v-flex md12> <b>Nro: </b> {{ form.id }} </v-flex>
              <v-flex md12> <b>Nro: </b> {{ form.id_jefe }} </v-flex>

              <v-flex md12>
                <v-textarea
                  label="Motivo de rechazo"
                  v-model="form.observacion"
                  maxlength="250"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            :loading="loading"
            @click.native="save(46)"
            :disabled="!valid"
          >
            Aprobar
          </v-btn>
          <v-btn
            dark
            color="red"
            @click.native="save(47)"
            :loading="loading"
            :disabled="!valid"
          >
            Rechazar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogAbrobarObservarListaFicha", item => {
      this.form = item;

      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      // this.valid = false
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async sendMessage() {
      let correo = await this.getMail();
      try {
        let body = {
          mail: correo,
          asunto: "Observación ficha personal",
          message: this.form.observacion
        };

        const token = this.$storage.get("token");
        const url = process.env.API_URL + "system/sendmail";

        const options = {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(body)
        };

        var data = await fetch(url, options);
        data = await data.json();
        if (data.mensaje == "Success") {
          this.$message.success("Se envio el correo");
        } else {
          this.$message.error(data.mensaje);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMail() {
      try {
        let res = await this.$service.graphql({
          query: `
					query{
						persona(id: ${this.form.id_persona}){
							usuarios{
								correo
							}
						}
						}
				`
        });
        return res.persona.usuarios[0].correo;
      } catch (err) {
        console.log(err);
      }
    },
    async save(id_nuevo_estado) {
      let resp = 0;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const user = this.$storage.get("user");
          if (id_nuevo_estado == 40) {
            if (this.form.observacion == null || this.form.observacion == "") {
              this.$message.error("Debe incluir una observacion");
              this.loading = false;
              return;
            } else {
              this.sendMessage();
            }
          }
          let respuesta = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select vacaciones.fn_aprueba_vaca_progra(${this.form.id},${id_nuevo_estado},${this.form.id_jefe},'${this.form.observacion}')"){
								respuesta
							}
							}
						`
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_aprueba_vaca_progra;

          let resps = respuesta.split("|");
          let correcto = resps[0];

          if (correcto === "1") {
            this.$message.success();
            this.close();
          } else {
            this.$message.error(resps);
          }
        } catch (error) {
          console.log(error);
        }

        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones_aprobar/dialogs/AbrobarObservarListaFicha.vue